export default __webpack_public_path__ + "dad162dc1a9997f72217cf2f2f56de51.svg";